import { FieldRenderer } from 'plugins/types';
import { GenericFieldRenderer } from './GenericFieldRenderer';

export const UserFieldRenderer: FieldRenderer = (props) => <GenericFieldRenderer icon="User-icon" {...props} />;
